import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa'; // Import the icon

type Props = {};

const TranslateMoreLinks = (props: Props) => {
  const [isTranslateOpen, setIsTranslateOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="relative">
      <button
        onClick={() => setIsTranslateOpen(!isTranslateOpen)} // Toggle submenu
        className={`w-full text-left p-3 mb-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 flex items-center justify-between ${
          location.pathname.includes('translate') ? 'relative' : ''
        }`}
      >
        {location.pathname.includes('translate') && (
          <span className="absolute top-1 left-[14px] w-3 h-3 bg-blue-500 rounded-full"></span>
        )}
        <span className="ml-4">Translate</span> {/* Added margin-left to keep the text in place */}
        <FaChevronDown
          className={`transition-transform ${
            isTranslateOpen ? 'transform rotate-180' : ''
          }`}
        />
      </button>

      {/* Submenu with smoother Tailwind CSS transition */}
      <div
        className={`overflow-hidden px-2 py-1 transition-all duration-300 ease-in-out ${
          isTranslateOpen ? 'max-h-fit opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="pl-4">
          <NavLink
            to="translate/prayernames" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 ${
                isActive ? 'bg-gray-200' : ''
              }`
            }
          >
            Prayer Names
          </NavLink>
        </div>
        <div className="pl-4">
          <NavLink
            to="translate/gregorianmonths" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 ${
                isActive ? 'bg-gray-200' : ''
              }`
            }
          >
            Gregorian Months
          </NavLink>
        </div>
        <div className="pl-4">
          <NavLink
            to="translate/gregoriannumbers" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 ${
                isActive ? 'bg-gray-200' : ''
              }`
            }
          >
            Gregorian Numbers
          </NavLink>
        </div>
        <div className="pl-4">
          <NavLink
            to="translate/hijramonths" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 ${
                isActive ? 'bg-gray-200' : ''
              }`
            }
          >
            Hijra Months
          </NavLink>
        </div>
        <div className="pl-4">
          <NavLink
            to="translate/hijranumbers" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 ${
                isActive ? 'bg-gray-200' : ''
              }`
            }
          >
            Hijra Numbers
          </NavLink>
        </div>
        <div className="pl-4">
          <NavLink
            to="translate/timetableprayer" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 ${
                isActive ? 'bg-gray-200' : ''
              }`
            }
          >
            Timetable Prayer
          </NavLink>
        </div>
        <div className="pl-4">
          <NavLink
            to="translate/verticaldailyprayer" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 ${
                isActive ? 'bg-gray-200' : ''
              }`
            }
          >
            Vertical Daily Prayer
          </NavLink>
        </div>
        <div className="pl-4">
          <NavLink
            to="translate/extra_info" 
            className={({ isActive }) =>
              `block p-2 mb-2 rounded-lg hover:bg-gray-100 transition-colors duration-200 ${
                isActive ? 'bg-gray-200' : ''
              }`
            }
          >
            Extra Info
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default TranslateMoreLinks;
